import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // If user is not logged in, redirect to login
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['auth', 'login']);
      localStorage.setItem('redirectUrl', state.url);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth-guard.service.ts